import { FlexColumn, FlexRow, FlexRowBetween, Line } from 'components'

import styled from 'styled-components'
import { useAuth } from 'context'
// import { CaretRight } from 'phosphor-react'
import React, { useState } from 'react'
import { Input, notification, Spin } from 'antd'
import { FirebaseService } from 'utility'

const StyledParagraph = styled.p`
  font-size: 16px;
  color: #4c4c4c;
  margin: 0 !important;
`
const SettingsButton = styled.button`
  border: 1px solid #b3b3b3;
  background: transparent;
  color: #1a1a1a;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }
`
const SettingsSection = styled.section`
  h5 {
    font-size: 18px;
  }
`

export const GenralTab = () => {
  const [password, setPassword] = useState('')
  const [passwordChanged, setPasswordChanged] = useState(false)
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)
  const { logout } = useAuth()
  const onSubmit = async () => {
    try {
      setLoading(true)
      await FirebaseService.updateUserPassword(password)
      notification.success({
        message: 'Success!',
        description: 'Password Updated SuccessFully',
      })
      logout()
    } catch (error) {
      notification.error({
        description: error.toString(),
        message: 'Failed to Update Password',
      })
    } finally {
      setLoading(false)
      setPasswordChanged(false)
    }
  }
  return (
    <div>
      <SettingsSection>
        <FlexRowBetween>
          <FlexColumn>
            <h5>Contacts</h5>
            <FlexColumn>
              <FlexRow>
                <StyledParagraph>Phone:</StyledParagraph>
                <StyledParagraph className="ms-2">
                  {user?.phoneNumber}
                </StyledParagraph>
              </FlexRow>
              <FlexRow className="align-items-center">
                <StyledParagraph>Mail:</StyledParagraph>
                <StyledParagraph className="ms-2">
                  {user?.email}
                </StyledParagraph>
              </FlexRow>
            </FlexColumn>
          </FlexColumn>
          <SettingsButton>Edit</SettingsButton>
        </FlexRowBetween>
        <Line className="my-3" />
        <FlexRowBetween>
          <FlexColumn>
            <h5>Change Password</h5>
            {passwordChanged ? (
              <Input.Password
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            ) : (
              <StyledParagraph className="ms-2">************</StyledParagraph>
            )}
          </FlexColumn>
          {passwordChanged ? (
            <div className="d-flex">
              <SettingsButton
                className="me-2"
                onClick={() => {
                  setPasswordChanged(false)
                  setPassword('')
                }}
              >
                Cancel
              </SettingsButton>
              <SettingsButton onClick={onSubmit}>
                Update {loading && <Spin />}
              </SettingsButton>
            </div>
          ) : (
            <SettingsButton onClick={() => setPasswordChanged(true)}>
              Edit
            </SettingsButton>
          )}
        </FlexRowBetween>
        <Line className="my-3" />
        {/* <FlexRowBetween>
          <FlexColumn>
            <h5>Supported Language</h5>
            <StyledParagraph className="ms-2">English</StyledParagraph>
          </FlexColumn>
          <SettingsButton>Edit</SettingsButton>
        </FlexRowBetween>
        <Line className="my-3" /> */}
        {/* <FlexRowBetween>
          <FlexColumn>
            <h5>Time Zone Settings</h5>
            <StyledParagraph className="ms-2">English</StyledParagraph>
          </FlexColumn>
          <SettingsButton>Edit</SettingsButton>
        </FlexRowBetween>
        <Line className="my-3" /> */}
        {/* <FlexRowBetween>
          <FlexColumn>
            <h5>Default Language</h5>
            <StyledParagraph className="ms-2">English</StyledParagraph>
          </FlexColumn>
          <SettingsButton>Edit</SettingsButton>
        </FlexRowBetween>
        <Line className="my-3" /> */}
        {/* <FlexRowBetween>
          <FlexColumn>
            <h5>Maintenance Mode</h5>
          </FlexColumn>
          <CaretRight />
        </FlexRowBetween> */}
      </SettingsSection>
      {/* <Line className="my-3" /> */}
    </div>
  )
}
